const meta = {
  manage: 'Manage SLOs',
  design: 'Design SLOs',
};

export default meta;
